import moment from 'moment';
import "moment-timezone";
import React, { useEffect, useState } from "react";
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator';
import UsersService from "../../utils/UsersService";
import ScheduleCalendar from './schedule/ScheduleCalendar';

const ScheduleView = ({ singleUser }) => {
  const [availabilityPeriods, setAvailabilityPeriods] = useState([]);
  const [deals, setDeals] = useState([]);
  const [view, setView] = useState({ view: "week", begin: moment().startOf("week"), end: moment().endOf("week")});

  const getEvents = (begin, end) => {
    const params = {}
    if (singleUser) params.users = [singleUser.id]
    UsersService.getAvailabilitySchedules(begin, end, params).then((data) => {
      setAvailabilityPeriods(data.availability_periods);
      setDeals(data.deals);
    });
  };

  useEffect(() => {
    getEvents(view.begin, view.end);
  }, [singleUser]);

  const dateRangeChanged = (view, begin, end) => {
    setView({ begin: begin, end: end, view: view})
    getEvents(begin, end);
  }

  return (
    <>
      <h3 style={{marginTop:0}}>Availability Schedules</h3>
      <LoadingIndicator>
        <div style={{ height: "85vh" }}>
          <ScheduleCalendar
            dateRangeChanged={dateRangeChanged}
            view={view.view}
            begin={view.begin}
            end={view.end}
            availabilityPeriods={availabilityPeriods}
            deals={deals}
            singleUser={singleUser !== null}
          />
        </div>
      </LoadingIndicator>
    </>
  );
};

export default ScheduleView;
